import { InternalRefetchQueriesInclude, useApolloClient } from '@apollo/client';

export const useApolloRefetcher = () => {
  const apolloClient = useApolloClient();

  const callRefetchQueries = async (
    refetchQueries: InternalRefetchQueriesInclude,
  ) => {
    if (!Array.isArray(refetchQueries)) {
      await apolloClient.refetchQueries({ include: refetchQueries });
      return;
    }

    await Promise.all(
      refetchQueries.map((q) => {
        return apolloClient.refetchQueries({ include: [q as any] });
      }),
    );
  };

  return {
    callRefetchQueries,
  };
};
